export const SET_CENTER_POINT = 'SET_CENTER_POINT'
export const PUSH_POINT = 'PUSH_POINT'
export const REMOVE_ALL_POINTS = 'REMOVE_ALL_POINT'
export const SET_FEATURE_COLLECTION = 'SET_FEATURE_COLLECTION'
export const SET_MESHDATA = 'SET_MESHDATA'
export const SET_MESHHEADERS = 'SET_MESHHEADERS'
export const SET_RELEVANT_DATA = 'SET_RELEVANT_DATA'
export const SET_LOADING_STATUS = 'SET_LOADING_STATUS'
export const SET_SAMPLE_LIST = 'SET_SAMPLE_LIST'
export const SET_MEASURES = 'SET_MEASURES'